import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { DefaultPopup } from '@atlas/ui';

import { BASE_PATH } from 'common/constants';

const PayMayaPopup = ({ id }) => {
  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <DefaultPopup className="qr-modal" headerTitle="paymaya" onClose={handleClose}>
      <div
        className="popup__content paymaya"
        style={{
          backgroundImage: `url("${BASE_PATH}/static/assets/images/qr-code-bg-paymaya.png")`,
        }}
      />
    </DefaultPopup>
  );
};

PayMayaPopup.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PayMayaPopup;
